import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { useSubdomain } from '../../../utils/contexts/UrlProvider'
import WidgetsList from './widget/WidgetsList'

const UserDetails = () => {
  const { t } = useTranslation()

  return (
    <Grid justify="flex-start" align="flex-start" paddingGutter={0.5} wrap>
      <Col width="100%">
        <WidgetsList />
      </Col>
    </Grid>
  )
}

export default UserDetails
